import docCookies from "doc-cookies";

$(function() {
  const cookie = docCookies.getItem("honest-modal");

  if (!cookie) {
    setTimeout(() => {
      $("#honest-modal").modal("show");
    }, 3000);
    docCookies.setItem("honest-modal", true, 60);
  }
});
